import { StayStoreType } from '@/types/store/stay-store.type';

export const state: StayStoreType = {
  stays: null,
};
